"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_redux_1 = require("react-redux");

var react_1 = require("react");

var react_redux_2 = require("@nimles/react-redux");

var react_2 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var imageBaseUrl = 'https://media.nimles.com/file';
var StyledImage = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n  background: ", ";\n"], ["\n  max-width: 100%;\n  background: ", ";\n"])), function (_a) {
  var background = _a.background;
  return background;
});

exports.Image = function (_a) {
  var value = _a.value,
      uri = _a.uri,
      image = _a.image,
      background = _a.background,
      width = _a.width;

  var _b;

  var dispatch = react_redux_1.useDispatch();
  var images = react_redux_1.useSelector(function (_a) {
    var files = _a.files;
    return files.values;
  });
  var source;
  var imageId;

  if (image) {
    if (((_b = image.uri) === null || _b === void 0 ? void 0 : _b.indexOf('data')) === 0) {
      source = image.uri;
    } else {
      source = imageBaseUrl + "/" + image.tenantId + "/" + image.id + "?width=" + (width !== null && width !== void 0 ? width : '860');
    }
  } else if (value) {
    if (value.indexOf('data') === 0) {
      source = value;
    } else if (value.indexOf('http') === 0) {
      source = value + "?width=" + (width !== null && width !== void 0 ? width : '860');
    } else if (value.indexOf('/') === 0) {
      source = "" + imageBaseUrl + value + "?width=" + (width !== null && width !== void 0 ? width : '860');
    } else {
      imageId = value;
      image = images && imageId && images.find(function (i) {
        return i.id === imageId;
      });

      if (image) {
        source = image.uri + "?width=" + (width !== null && width !== void 0 ? width : '860');
      }
    }
  } else if (uri) {
    source = uri + "?width=" + (width !== null && width !== void 0 ? width : '860');
  }

  react_1.useEffect(function () {
    if (imageId && !source) {
      dispatch(react_redux_2.loadFile(imageId));
    }
  }, [imageId, source]);
  return source ? react_2.default.createElement(StyledImage, {
    src: source,
    background: background
  }) : null;
};

var templateObject_1;